import { InvoiceTaxModel } from './invoicetax.model';

export class AccountsAndTaxesModel {

  taxes: InvoiceTaxModel[];
  accounts: {}[];

  constructor() { }
}
